import * as React from 'react';
import { instanceToPlain, plainToInstance } from 'class-transformer';
import { Button } from '@mui/material';
import { PlusOutlined } from '@ant-design/icons';
import FormStepper from 'components/form-stepper/FormStepper';
import { TypeMode } from 'constants/TypeMode';
import StandardModalForm from 'components/shared/StandardModalForm';

// eslint-disable-next-line react/prop-types
const AddDataStandardModalForm = ({
    config,
    entity,
    onClose,
    onSubmit,
    style,
}) => {
    const [open, setOpen] = React.useState(false);

    const handleOpenModal = () => {
        setOpen(true);
    };

    const handleOnClose = action => {
        onClose(action);
        setOpen(false);
    };

    const defaultValue = React.useMemo(() => {
        let value = plainToInstance(entity, { exposeDefaultValues: true });
        delete value?.id;
        delete value?.uuid;
        return value;
    }, [entity]);

    const handleOnSubmit = async (data, successCallback, errorCallback) => {
        onSubmit(data, successCallback, errorCallback);
        handleOnClose();
    };

    return (
        <>
            <Button
                variant="contained"
                onClick={handleOpenModal}
                startIcon={<PlusOutlined />}
                size="small"
                style={style}
            >
                Add
            </Button>
            <StandardModalForm
                mode={TypeMode.Create}
                formConfig={config}
                defaultValue={instanceToPlain(defaultValue)}
                onClose={handleOnClose}
                onSubmit={handleOnSubmit}
                open={open}
                maxWidth={'md'}
            >
                {({ formConfig, methods, watch, defaultValue, mode }) => (
                    <FormStepper
                        forms={formConfig}
                        watch={watch}
                        mode={mode}
                        methods={methods}
                        defaultValue={defaultValue}
                        showHeader={false}
                    />
                )}
            </StandardModalForm>
        </>
    );
};

export default AddDataStandardModalForm;
